import { QuestionBlockHelper } from './question-block';

export interface QuestionRecapPair {
  question: string;
  /** Empty when the answer is not known here, in which case the row shows the question alone. */
  answer: string;
}

interface QuestionAnsweredRecapProps {
  pairs: QuestionRecapPair[];
}

/** The resolved state of a question card: each question with the answer given, per the Figma
 * "Answered pair". Deliberately dumb, so the stored record and the legacy fence format can both
 * feed it without either knowing about the other. */
export function QuestionAnsweredRecap({ pairs }: QuestionAnsweredRecapProps) {
  if (pairs.length === 0) return null;
  const keys = QuestionBlockHelper.uniqueKeys(
    pairs.map((pair) => pair.question)
  );

  return (
    <div className="my-sm flex w-full flex-col gap-lg rounded-2xl border-[0.5px] border-border-tertiary bg-bg-light p-xl">
      {pairs.map((pair, index) => (
        <div key={keys[index]} className="flex flex-col gap-xxs">
          <span className="txt-extra-small-medium text-text-tertiary">
            {pair.question}
          </span>
          {pair.answer && (
            <span className="txt-small-regular text-text-primary">
              {pair.answer}
            </span>
          )}
        </div>
      ))}
    </div>
  );
}
